import React, { useState, useEffect } from 'react';
import * as apiClient from '../../apiClient';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, CircularProgress, TextField, IconButton, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useRedirect } from "react-admin";

export const Lookup = props => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [search, setSearch] = useState('');
    const redirect = useRedirect();

    useEffect(() => {
        const loadData = async () => {
            let userId = localStorage.getItem('userId');
            if (userId) {
                userId = parseInt(userId);
            }

            setIsLoading(true);
            const requestData = {
                userId,
                candidateId: props.record.id,
            };

            try {
                const res = await apiClient.getNotificationsByRecruiter(requestData);
                setData(res);
            } catch (err) {
                console.error('Error fetching data:', err);
            } finally {
                setIsLoading(false);
            }
        };

        loadData();
    }, [props.record.id]);

    const filteredData = data.filter(row => 
        Object.entries(row).some(([key, value]) => 
            key !== 'ID' && value.toString().toLowerCase().includes(search.toLowerCase())
        )
    );

    const handleSubmit = async (item) => { 
        let userId = localStorage.getItem('userId');
        if (userId) {
            userId = parseInt(userId);
        } 
        let formData = []; 
        formData.push({ id: 0, NotificationID: item.ID, EmployeeID: props.record.id, TypeId: props.record.typeId, UserId: userId })
        
        apiClient.addResource({ data: formData }).then((res) => {
            if (res[0].result === true) { 
                redirect(`recruiternotifications/1/5?CandidateID=${props.record.id}`);
            } else { 
                alert(res[0].message); 
            }
        });
    };

    return (
        <div style={{ position: 'relative', width: '100%', height: '100vh', padding: '10px' }}>
            <IconButton 
                onClick={() => props.onCancel()} 
                style={{ position: 'absolute', right: 10, top: 10 }}
            >
                <CloseIcon />
            </IconButton>
            <TextField 
                label="Search" 
                variant="outlined" 
                size="small" 
                style={{ marginBottom: '10px', width: '200px' }} 
                onChange={(e) => setSearch(e.target.value)} 
            />
            {isLoading ? (
                <CircularProgress />
            ) : (
                <TableContainer component={Paper} style={{ height: 'calc(100vh - 60px)', overflowY: 'auto' }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                {data.length > 0 && Object.keys(data[0]).map((key) => (
                                    key !== 'ID' && <TableCell key={key}>{key}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredData.map((row, index) => (
                                <TableRow key={index}>
                                    {Object.entries(row).map(([key, value], i) => (
                                        key === 'IsCandidateAdded' ? (
                                            <TableCell key={i}>
                                                {value === 'YES' ? (
                                                    <Button 
                                                        variant="contained" 
                                                        style={{ backgroundColor: '#77B254', color: 'white', minWidth: 120 }}
                                                        onClick={() => redirect(`recruiternotifications/${row.ID}/5?CandidateID=${props.record.id}`)}
                                                    >
                                                       View 
                                                    </Button>
                                                ) : (
                                                    <Button 
                                                        variant="contained" 
                                                        style={{ backgroundColor: '#EB5A3C', color: 'white', minWidth: 120 }}
                                                        onClick={() => handleSubmit(row)}
                                                    >
                                                       
                                                       Add & View
                                                    </Button>
                                                )}
                                            </TableCell>
                                        ) : key !== 'ID' && (
                                            <TableCell key={i}>{value}</TableCell>
                                        )
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </div>
    );
};
